var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaytm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Paytm",
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.838,
    height: 9.999,
    viewBox: "0 0 31.838 9.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2146",
    "data-name": "Path 2146",
    d: "M211.958,14.255a2.22,2.22,0,0,1,2.91.15,2.328,2.328,0,0,1,1.413-.623,2.1,2.1,0,0,1,2.235,2.019v5.97c0,.332-.085.419-.424.42h-1.167c-.376,0-.469-.092-.469-.468V16.47c0-.43-.19-.616-.614-.615s-.614.188-.614.617V21.75c0,.369-.08.442-.45.449h-1.194c-.317,0-.413-.087-.416-.406-.007-1.246-.008-2.493-.01-3.74V16.435c0-.39-.19-.566-.6-.567-.429,0-.62.171-.62.573v5.28c0,.388-.081.47-.46.47h-1.194c-.3,0-.406-.1-.406-.392V14.237c0-.281.111-.381.385-.384h1.216C211.835,13.852,211.891,13.9,211.958,14.255Z",
    transform: "translate(-186.678 -12.252)",
    fill: "#01baf1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2147",
    "data-name": "Path 2147",
    d: "M58.095,19.358v2.625a.834.834,0,0,1-.936.926H54.665a1.842,1.842,0,0,1-1.975-1.893c-.019-.6-.018-1.2,0-1.8a1.879,1.879,0,0,1,1.719-1.867c.377-.042.758-.036,1.138-.044s.442-.066.442-.366-.1-.386-.46-.386H53.937c-.325,0-.423-.1-.426-.43V14.955a.31.31,0,0,1,.337-.355c.795,0,1.593-.029,2.383.038a1.851,1.851,0,0,1,1.861,2.068C58.1,17.59,58.095,18.474,58.095,19.358Zm-3.326.8v.08c-.033.914.069.83.884.826.249,0,.368-.13.375-.38.007-.211,0-.423,0-.636.024-.851-.014-.825-.9-.813h-.027a.332.332,0,0,0-.332.366C54.767,19.784,54.768,19.968,54.768,20.154Z",
    transform: "translate(-46.853 -12.981)",
    fill: "#063070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2148",
    "data-name": "Path 2148",
    d: "M113.56,17.957v2.811a2.022,2.022,0,0,1-2.157,2.157h-2.148c-.353,0-.442-.084-.442-.442V21.267c0-.3.1-.392.4-.394h1.75c.4,0,.547-.111.538-.352s-.151-.315-.539-.319a6.557,6.557,0,0,1-1.105-.035,1.968,1.968,0,0,1-1.673-2.069c-.015-1.034-.006-2.068,0-3.1,0-.319.111-.422.436-.425h1.167c.367,0,.465.1.468.475v2.6c0,.43.076.505.513.506.727,0,.732,0,.732-.715V15c0-.323.1-.423.429-.425h1.216c.3,0,.411.116.411.42Q113.563,16.473,113.56,17.957Z",
    transform: "translate(-96.217 -12.959)",
    fill: "#073070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2149",
    "data-name": "Path 2149",
    d: "M2.061,20.38v2c0,.368-.087.457-.442.457H.373C.09,22.841,0,22.753,0,22.48V14.873c0-.262.1-.371.366-.373,1.042,0,2.086-.018,3.127.007a1.744,1.744,0,0,1,1.821,1.669,16.223,16.223,0,0,1-.008,2.591,1.751,1.751,0,0,1-1.817,1.611C3.019,20.386,2.554,20.38,2.061,20.38Zm.017-3.812v1.74c.3,0,.576.006.857,0a.325.325,0,0,0,.345-.353c.009-.343.008-.687,0-1.03a.332.332,0,0,0-.346-.355c-.28-.01-.559,0-.856,0Z",
    transform: "translate(0 -12.892)",
    fill: "#052f6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2150",
    "data-name": "Path 2150",
    d: "M167.274,1.606h.713c.294,0,.406.111.408.4V3.275c0,.286-.111.395-.4.4h-.709V9.5c0,.442-.061.5-.51.5h-1.034c-.415,0-.481-.066-.481-.472V3.675h-.765c-.3,0-.4-.1-.4-.395v-1.3c0-.26.111-.375.369-.373a1.951,1.951,0,0,0,1.691-.918,2.439,2.439,0,0,1,.632-.619c.264-.175.483-.021.489.3C167.278.773,167.274,1.169,167.274,1.606Z",
    transform: "translate(-145.95 0.001)",
    fill: "#01b9f1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaytm);
export default __webpack_public_path__ + "static/media/paytm.00ac9017ce84586f28b6855b5d76c915.svg";
export { ForwardRef as ReactComponent };